<template>
  <div class="business-license">
    <div class="header">
      <h1>商家资质</h1>
    </div>
    <div class="store-info">
      <p>店铺：{{shopInfo.shopname}}</p>
      <p>主体：{{shopInfo.address}}</p>
    </div>
    <div class="license-section">
      <h2>营业执照</h2>
      <p>根据相关法律法规要求对网店经营者资质信息公示如下：</p>
      <div style="margin: 0; padding: 0;" v-for="img in list" :key="img">
        <img style="display: flex;" :src="img" alt="营业执照" />
      </div>
    </div>
    <div class="note">
      <p>
        注：以上经营信息由卖家自行申报填写，具体以工商部门登记为准，如需核实请联系当地工商部门。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessLicense",
  data(){
    return{
      list:[],
      shopInfo:null
    }
  },
  created(){
    console.log(this.$route.query)
    this.list = this.$route.query.shoplicense.split(',')
    this.shopInfo = this.$route.query
  }
};
</script>

<style scoped>
.business-license {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.store-info {
  font-size: 18px;
  margin-bottom: 20px;
}

.license-section {
  margin-bottom: 20px;
}

.license-section img {
  width: 100%;
  max-width: 600px;
  margin: 10px 0;
  border: 1px solid #ccc;
}

.note {
  font-size: 14px;
  color: #666;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/credential.vue